var $64b7e390f5791490$exports = {};
$64b7e390f5791490$exports = {
  "ascending": "oplopend",
  "ascendingSort": function ascendingSort(args) {
    return "gesorteerd in oplopende volgorde in kolom ".concat(args.columnName);
  },
  "columnSize": function columnSize(args) {
    return "".concat(args.value, " pixels");
  },
  "descending": "aflopend",
  "descendingSort": function descendingSort(args) {
    return "gesorteerd in aflopende volgorde in kolom ".concat(args.columnName);
  },
  "resizerDescription": "Druk op Enter om het formaat te wijzigen",
  "select": "Selecteren",
  "selectAll": "Alles selecteren",
  "sortable": "sorteerbare kolom"
};
export { $64b7e390f5791490$exports as default };